import React, { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Segment, Container } from 'semantic-ui-react'
import { Trans } from 'react-i18next'
import { FOOTER_HEIGHT } from '../../constants'
import styles from '../styles'

export const Footer = () => {
  const { footer, footerColor, footerFixed } = useSelector(state => state.page)
  const [segmentStyle, setSegmentStyle] = useState({})

  useEffect(() => {
    if (footerFixed) {
      setSegmentStyle({
        width: '100%',
        height: `${FOOTER_HEIGHT}px`,
        marginTop: 0,
        borderRadius: 0,
        backgroundColor: footerColor
      })
    } else {
      setSegmentStyle({
        width: '100%',
        height: `${FOOTER_HEIGHT}px`,
        marginTop: 0,
        borderRadius: 0,
        backgroundColor: footerColor
      })
    }
  }, [footerFixed])

  const footerStyle = {
    marginTop: '3rem',
    position: 'relative',
    bottom: 0,
    height: 'fit-content',
    display: 'flex',
    justifyContent: 'space-around',
    flex: 2
  }

  const linkColumnStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flex: '0 1 auto',
    lineHeight: 0,
    marginRight: '5.625rem',
    fontSize: '1.2rem'
  }

  const linkStyle = {
    color: 'white'
  }

  return (
    footer &&
      <Segment inverted style={segmentStyle}>
        <Container fluid color={footerColor} style={footerStyle}>
          <div style={{ ...styles.centerStyle, flex: '1', flexDirection: 'column', gap: '1rem' }}>
            <img src='/images/Logo.png' />
            <p style={{ width: '19rem', marginLeft: '6rem', fontSize: '1.2rem' }}><Trans i18nkey='footer.link.copyright'>Copyright © 2024 Sphero, Inc. All rights reserved.</Trans></p>
          </div>
          <div style={{ flex: '2', display: 'flex', justifyContent: 'center' }}>
            <div style={linkColumnStyle} className='footer'>
              <p><a href={`${window.location.origin}/d`} target='_blank' rel='noreferrer' style={linkStyle}><Trans i18nkey='footer.link.edu_app'>Sphero Apps and Software</Trans></a></p>
              <p><a href='https://sphero.com/blogs/news' target='_blank' rel='noreferrer' style={linkStyle}><Trans i18nkey='footer.link.blog'>Blog</Trans></a></p>
              <p><a href='https://support.sphero.com/en-US/articles/edu-72285' target='_blank' rel='noreferrer' style={linkStyle}><Trans i18nkey='footer.link.about'>About</Trans></a></p>
            </div>
            <div style={linkColumnStyle} className='footer'>
              <p><a href='https://support.sphero.com/' target='_blank' rel='noreferrer' style={linkStyle}><Trans i18nkey='footer.link.support'>Support</Trans></a></p>
              <p><a href='https://sphero.com/collections/all' target='_blank' rel='noreferrer' style={linkStyle}><Trans i18nkey='footer.link.store'>Store</Trans></a></p>
              <p><a href='http://www.sphero.com/privacy' target='_blank' rel='noreferrer' style={linkStyle}><Trans i18nkey='footer.link.privacy'>Privacy Policy</Trans></a></p>
              <p><a href='/child-policy' style={linkStyle} target='_blank' rel='noreferrer'><Trans i18nkey='footer.link.edu_privacy'>EDU Privacy Policy</Trans></a></p>
              <p><a href='https://sphero.com/pages/terms-of-use' target='_blank' rel='noreferrer' style={linkStyle}><Trans i18nkey='footer.link.terms'>Terms</Trans></a></p>
              <p><a href='https://sphero.com/pages/do-not-sell-my-personal-information' target='_blank' rel='noreferrer' style={linkStyle}><Trans i18nkey='footer.link.california_privacy'>California Consumer Privacy Act Requests</Trans></a></p>
            </div>
          </div>
        </Container>
      </Segment>
  )
}

export default memo(Footer)
